<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="ts-flex ts-item-end">
        <ts-input
          v-tooltip="$t('productProfile.searchPurchaseInvoice')"
          v-model="search"
          :placeholder="$t('productProfile.searchPurchaseInvoice')"
          style="width: 100%;"
          class="inline-block"
        />
      </div>
      <div class="overflow-auto ts-mt-3">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td>{{ record.branch_name_en }}</td>
            <td>{{ record.invoice_no }}</td>
            <td>{{ record.po_number }}</td>
            <td>{{ record.reference_no }}</td>
            <td>{{ $currencyFormat(record.invoice_amount) }}</td>
            <td>{{ record.vendor_name }}</td>
            <td>{{ record.location_name_en }}</td>
            <td class="ts-text-center">
              <span class="badge badge-success" v-if="record.is_confirm_stock"
                >Yes</span
              >
              <span class="badge badge-danger" v-else>No</span>
            </td>
            <td>{{ record.confirmed_date }}</td>
            <td>{{ record.name }}</td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-between align-items-center p-15">
        <ts-total-list v-model="pagination" />
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { debounce } from 'lodash'
export default {
  name: 'purchaseInvoiceDetail',
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState('product/productDetailPurchaseInvoice', [
      'resources',
      'pagination'
    ]),
    search: {
      get() {
        return this.$store.state.product.productDetailPurchaseInvoice.search
      },
      set(newValue) {
        this.$store.commit(
          'product/productDetailPurchaseInvoice/SET_SEARCH',
          newValue
        )
        this.$store.commit(
          'product/productDetailPurchaseInvoice/RESET_CURRENT_PAGE'
        )
      }
    },
    columns() {
      return [
        { name: this.$t('productProfile.branch'), style: 'width: 7%' },
        { name: this.$t('productProfile.piNumber') },
        { name: this.$t('productProfile.poNumber') },
        { name: this.$t('productProfile.vendorInvoice#') },
        { name: this.$t('productProfile.amount') },
        { name: this.$t('productProfile.supplier') },
        { name: this.$t('productProfile.warehouse') },
        {
          name: this.$t('productProfile.confirmStock'),
          style: 'text-align:center'
        },
        { name: this.$t('productProfile.confirmDate') },
        { name: this.$t('productProfile.confirmBy') }
      ]
    }
  },
  methods: {
    ...mapActions('product/productDetailPurchaseInvoice', ['fetch']),
    fetchData() {
      this.loading = true
      this.fetch(this.$route.params.id)
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  watch: {
    search: debounce(function() {
      this.fetchData()
    }, 500)
  }
}
</script>
